import { locizeNS, translate } from 'Services/i18n';
import {
  NO_PASSWORD_URL,
  NO_REMEMBER_RFC_URL,
  NO_RFC_URL,
  WHY_THIS_INFORMATION_URL,
} from 'Constants/helpsUrl';
import { openLinkInNewTab } from 'Utils/links';

export const doubtsList = (): { label: string; action: () => void }[] => [
  {
    label: translate('Dg.faqs.1', locizeNS.DG),
    action: (): void => openLinkInNewTab(WHY_THIS_INFORMATION_URL),
  },
  {
    label: translate('Dg.faqs.2', locizeNS.DG),
    action: (): void => openLinkInNewTab(NO_RFC_URL),
  },
  {
    label: translate('Dg.faqs.3', locizeNS.DG),
    action: (): void => openLinkInNewTab(NO_REMEMBER_RFC_URL),
  },
  {
    label: translate('Dg.faqs.4', locizeNS.DG),
    action: (): void => openLinkInNewTab(NO_PASSWORD_URL),
  },
];
